import React, { useEffect, useMemo, useRef, useState } from "react";
// import get from "lodash.get";
// import { useTranslation } from "react-i18next";
import { IDaySelectType, IDaysOfTheWeekState } from "./DaySelect.types";
import chevron from "./assets/images/chevron.svg";
import { DaySelectStyles, StyledInput } from "./DaySelect.styles";
// import { StyledButton } from "../../../assets/styles/Button";
// import CheckBox from "../../../modules/hr/components/checkBox/input";
// import { ICourseDay } from "../../../modules/orders/type/addOrder";
import { DAYS_OF_WEEK, STATIC_COURSE_DAYS } from "./DaySelect.constsnts";
// import useOutsideHandlerByBoolean from "./../../../hooks/useOutsideHandlerByBoolean/useOutsideHandlerByBoolean";
import CheckBox from "../Checkbox/Checkbox";
import useOutsideHandlerByBoolean from "../../hooks/useOutsideHandlerByBoolean/useOutsideHandlerByBoolean";
import { useTranslation } from "react-i18next";

const DaySelect = ({
  courseDays,
  label,
  selectedCourseDay,
  setSelectedCourseDay,
  otherDaysTitle,
  setOtherDaysTitle,
  otherDays,
  setOtherDays,
  defaultOtherDays = [],
}: IDaySelectType) => {
  const outsideOfSelectRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { t } = useTranslation();
  const [courseDayList, setCourseDayList] = useState<any[]>([
    ...STATIC_COURSE_DAYS,
  ]);

  const [daysOfTheWeekState, setDaysOfTheWeekState] =
    useState<IDaysOfTheWeekState[]>(DAYS_OF_WEEK);

  const toggling = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setCourseDayList([...STATIC_COURSE_DAYS, ...courseDays]);
  }, [courseDays]);

  useEffect(() => {
    updateDefaultOtherDays();
  }, []);

  const updateDefaultOtherDays = () => {
    const isChecked = (innerDay: number) => {
      return !!defaultOtherDays?.find((day) => day === innerDay);
    };

    if (otherDays) {
      setDaysOfTheWeekState((prev) => {
        const newDaysOfTheWeekState = prev.map((day: IDaysOfTheWeekState) => {
          return {
            ...day,
            checked: isChecked(day.value),
          };
        });
        return newDaysOfTheWeekState;
      });
    }
  };

  const courseDayClick = (
    courseDay: any | null,
    isOtherDays: boolean = false
  ) => {
    isOtherDays !== otherDays && setOtherDays(isOtherDays);
    if (courseDay !== selectedCourseDay && courseDay !== null) {
      setSelectedCourseDay(courseDay);
    }
    if (!isOtherDays) toggling();
  };

  useOutsideHandlerByBoolean(outsideOfSelectRef, setIsOpen);

  const dayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaysOfTheWeekState(
      daysOfTheWeekState.map((day: IDaysOfTheWeekState) => {
        if (e.target.value == day.value.toString())
          return {
            ...day,
            checked: e.target.checked,
          };
        return day;
      })
    );
  };

  const saveTheSelectedDays = () => {
    const days: number[] = [];
    let daysNames: string = "";
    for (const day of daysOfTheWeekState) {
      if (day.checked) {
        days.push(day.value);
        daysNames = daysNames.concat(day.label.substring(0, 2) + ", ");
      }
    }
    setSelectedCourseDay({
      days,
      title: otherDaysTitle ? otherDaysTitle?.trim() : daysNames.slice(0, -2),
    });
    setIsOpen(false);
  };

  const otherCourseItemClick = () => {
    setSelectedCourseDay(null);
    setOtherDays(true);
  };

  const otherDaysChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOtherDaysTitle(event.target.value || "");
  };

  const isActive = (courseDay: any | null) => {
    if (otherDays) return false;
    return courseDay?.title === selectedCourseDay?.title;
  };

  const labels = useMemo(() => {
    if (otherDays) {
      if (!daysOfTheWeekState.find((day) => day.checked)) return "";
      return daysOfTheWeekState?.map((day) => {
        return day.checked ? day.label?.slice(0, 2) + "," : "";
      });
    } else if (!selectedCourseDay) return null;
    else return t(`form.${selectedCourseDay.title}`);
  }, [otherDays, daysOfTheWeekState, selectedCourseDay]);

  return (
    <div className="mb-2">
      {label}
      <DaySelectStyles onClick={toggling} ref={outsideOfSelectRef}>
        <div className={`label ${labels && "value"}`}>
          {labels || t("form.selectDay")}
        </div>
        <div className="main ">
          <div className="drop-down-container">
            <div className="drop-down-header d-flex ">
              <img
                className={`chevron ${isOpen ? "chevron-rotate" : ""}`}
                src={chevron}
                alt=""
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <div
            className="drop-down-list-container"
            onClick={(e: any) => e.stopPropagation()}
          >
            <div className="drop-down-list">
              {courseDayList?.map((courseDay: any, i: number) => (
                <div
                  className={`list-item ${isActive(courseDay) ? "active" : ""}`}
                  onClick={() => courseDayClick(courseDay)}
                  key={i}
                >
                  {t(`form.${courseDay.title}`)}
                </div>
              ))}
              <div
                className={`list-item ${otherDays ? "active" : ""}`}
                onClick={otherCourseItemClick}
              >
                {t("form.otherDays")}
              </div>

              {otherDays && (
                <>
                  <div style={{ padding: "5px 30px", paddingRight: "8px" }}>
                    <StyledInput
                      type="text"
                      placeholder={t("form.type")}
                      onChange={otherDaysChange}
                      value={otherDaysTitle}
                    />
                  </div>
                  <div className="list-item-other">
                    {daysOfTheWeekState?.map((day: any, i: number) => {
                      return (
                        <div className="d-flex align-items-center" key={i}>
                          <CheckBox
                            params={{
                              checked: day.checked,
                              value: day.value,
                              onChange: dayChange,
                            }}
                            id={day.value.toString()}
                            label={t(`form.${day.label}`)}
                          />
                        </div>
                      );
                    })}
                    <div className="day-btn-wrapper">
                      <button
                        // type="button"
                        // style={{ borderRadius: "12px" }}
                        className="btn"
                        onClick={saveTheSelectedDays}
                      >
                        {t("form.save")}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </DaySelectStyles>
    </div>
  );
};

export default DaySelect;
